import React from "react";
import { connect } from "react-redux";
import { Table, Button, Tab } from "semantic-ui-react";
import _ from "lodash";
import addVehicleInfoRows from "../reports/VehicleInfo";
import ResultHeader from "./ResultHeader";
import "../../assets/styles/sub-table.css";
import { addReportIdToAdditionalData } from "../common/Utils";
import { getMenuItem } from "../common/PageHelper";

class VehicleDppaResult extends React.Component {
  constructor(props) {
    super(props);
    this.loadData(props);
  }

  componentDidMount() {
    window.addEventListener("resize", this.updateDimensions);
  }

  componentWillReceiveProps(nextProps) {
    this.loadData(nextProps);
  }

  loadData = (props) => {
    const results = [];
    let tabHeader;
    const vehRecIds = [];
    if (
      props.searchResultData !== undefined &&
      props.searchResultData !== null &&
      props.searchResultData !== ""
    ) {
      const resultNodes = _.get(
        props.searchResultData,
        "vehicles.motorVehicleSearch2Response[0].records[0].record"
      );
      const showNarrowSearchMessage =
        resultNodes !== undefined && resultNodes.length > 25;
      tabHeader = (
        <ResultHeader
          showNarrowSearchMessage={showNarrowSearchMessage}
          {...this.props}
        />
      );
      if (resultNodes)
        _.forEach(resultNodes, (node, index) => {
          const curVehRecId = _.get(
            node,
            "vehicleInfo[0].vehicleRecordId[0]._"
          );
          if (vehRecIds.indexOf(curVehRecId) === -1) {
            const rows = [];
            addVehicleInfoRows(props, node, rows, index);
            results.push(
              <Table.Row
                className={
                  vehRecIds.length % 2 === 1 ? "table-row-odd-child" : ""
                }
                key={`VehicleInfo_Row_${index}`}
              >
                <Table.Cell>
                  <Table
                    className={"table-no-border background-color-transparent"}
                  >
                    <Table.Body>
                      <Table.Row>
                        <Table.Cell colSpan={4}>
                          <div className={"float-right-nomobile"}>
                            <Button
                              id={node.$.internalID}
                              onClick={() => this.showReport(node.$.internalID)}
                            >
                              Report
                            </Button>
                          </div>
                        </Table.Cell>
                      </Table.Row>
                      {rows}
                    </Table.Body>
                  </Table>
                </Table.Cell>
              </Table.Row>
            );
            vehRecIds.push(curVehRecId);
          }
        });
    }
    const selectedRows = [];
    for (let index = 0; index < props.resultRecordCount; index += 1) {
      selectedRows[index] = false;
    }
    this.state = {
      selectedRows,
      results,
      resultsCount: vehRecIds.length,
      tabHeader,
    };
  };

  showReport = (internalID) => {
    const additionalData = {
      optReportType: "vehicle",
      lookupID: internalID,
      internalID,
    };
    addReportIdToAdditionalData(this.props, additionalData);
    this.props.showReport(undefined, "aReport", undefined, additionalData);
  };

  render() {
    const tabs = [];
    const { userAccount } = this.props;
    tabs.push({
      menuItem: getMenuItem(
        userAccount.acctTheme,
        true,
        `${this.state.resultsCount} Matches Found`
      ),
      render: () => (
        <Tab.Pane>
          {this.state.tabHeader}
          {this.state.results.length > 0 && (
            <Table stackable>
              <Table.Body>{this.state.results}</Table.Body>
            </Table>
          )}
        </Tab.Pane>
      ),
    });
    return <Tab panes={tabs} />;
  }
}

function mapStateToProps(state) {
  return { userAccount: state.userAccount };
}

export default connect(mapStateToProps, null)(VehicleDppaResult);



// WEBPACK FOOTER //
// ./src/components/searchresults/VehicleDppaResult.js